export default __webpack_public_path__ + "static/media/promo-universal.ee4c0919.png";